var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("navbar-header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-grow-1 body container-fluid d-flex flex-column" },
        [
          _c(
            "b-row",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "b-col",
                { staticClass: "m-auto", attrs: { md: "4" } },
                [
                  _c("h3", [_vm._v("Войти")]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    { on: { submit: _vm.onSubmit } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "emailInputGroup",
                            label: "Логин:",
                            "label-for": "emailInput"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "emailInput",
                              type: "text",
                              required: "",
                              placeholder: "Введите почту"
                            },
                            model: {
                              value: _vm.form.email,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "passwordInputGroup",
                            label: "Пароль:",
                            "label-for": "passwordInput"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "passwordInput",
                              type: "password",
                              required: "",
                              placeholder: "Введите пароль"
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        { attrs: { show: _vm.showError, variant: "danger" } },
                        [_vm._v(_vm._s(_vm.errorMessage))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "w-100",
                          attrs: { type: "submit", variant: "primary" }
                        },
                        [_vm._v("Войти")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("yandex-map", {
                staticStyle: { width: "200px", height: "200px" },
                attrs: { coords: [57.13717, 65.546001], zoom: "12" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb106bae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb106bae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoginLayout.vue
// module id = null
// module chunks = 